<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
						<div class="admin-page-group">
							<h1 class="admin-page">Crear Combo</h1>
							<router-link to="/combos" class="btn-link pull-right"><i class="fa fa-angle-left"></i> <span class="semibold">Volver al listado de Combos</span></router-link>
						</div>
						<div class="box-style line-top">
							<form class="form smart-form">
								<div class="box-header subline-top">
									<h2>SETEAR NUEVO COMBO</h2>
								</div>
								<div class="box-body">	
									<div class="row">
										<div class="col-xs-12">
											<div class="form-group">
												<label>Elija el nombre para su combo</label>
												<div class="input">
                          <input type="text" v-model="datosCombo.nombre" class="form-control" placeholder="Ej: Entrada + Plato Principal + Postre">
                          <span class="label label-danger" v-if="!$v.datosCombo.nombre.required && datosCombo.mostrarErrores">El nombre no puede estar vacío</span> 
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-12 col-sm-1 col-md-2 col-lg-1">
											<b class="label-rules">Regla:</b>
										</div>
										<div class="col-xs-12 col-sm-4 col-md-6 col-lg-6">
											<div class="form-group">
												<label>Categoría</label>
												<div class="select">
													<select class="form-control" v-model="formAgregar.idCategoria">
														<option>Elija...</option>
														<option :value="categoria._id" v-for="categoria in categorias">{{categoria.nombre}}</option>
													</select>
													<i class="fa fa fa-angle-down"></i>
                        </div>
                        <span class="label label-danger" v-if="!$v.formAgregar.idCategoria.required && formAgregar.mostrarErrores">Debe seleccionar una categoría</span>
											</div>
										</div>
										<div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
											<div class="form-group">
												<label>Cantidad</label>
                        <input type="number" v-model="formAgregar.cantidad" min="1" max="9999" class="form-control">
                        <span class="label label-danger" v-if="!$v.formAgregar.cantidad.between && formAgregar.mostrarErrores">Debe agregar por lo menos una categoría</span> 
											</div>
										</div>
										<div class="col-xs-12 col-sm-2 col-md-2 col-lg-3">
											<div class="form-group no-label">
												<button type="button" @click.prevent="clickAgregarRegla" class="btn btn-fill">AGREGAR</button>
											</div>
										</div>
									</div>
								</div>
								<div class="box-header subline-top">
									<h2>REGLAS DE COMBOS CREADAS</h2>
								</div>
								<div class="box-body">
									<div class="table-container">
										<table class="table table-hover table-stripped table-no-first-pad">
											<thead>
												<tr>
													<th>Categoría</th>
													<th>Cantidad</th>
													<th></th>
												</tr>
											</thead>
											<tbody v-for="regla, idx in datosCombo.reglas" :key="regla.categoria">
												<tr>
													<td>{{regla.categoria.nombre}}</td>
													<td>{{regla.cantidad}}</td>
													<td>
														<ul class="table-actions smart-form">
															<li>
																<a href="" @click.prevent="eliminarRegla(idx)" class="btn btn-xs btn-ghost" type="button">
																	<i class="fa fa-actions fa-times"></i>
																</a>
															</li>
														</ul>
													</td>
												</tr>
											</tbody>
                    </table>
                    <span class="label label-danger" v-if="!$v.datosCombo.reglas.minLength && datosCombo.mostrarErrores">Valor no válido</span> 
                  </div>
                  <div class="row text-center center-block">
                    <button class="btn btn-fill" @click.prevent="clickGuardarCombo">Guardar combo</button>
                  </div>
								</div>
							</form>
						</div>
					</div>
      </div>
    </div>
  </section>
</template>
<script>
  import { required, between, minLength } from 'vuelidate/lib/validators'
  export default {
    data () {
      return {
        datosCombo: {
          mostrarErrores: false,
          _id: null,
          nombre: '',
          reglas: []
        },
        categorias: [],
        formAgregar: {
          mostrarErrores: false,
          cantidad: 0,
          idCategoria: null
        }
      }
    },
    validations: {
      datosCombo: {
        nombre: {
          required
        },
        reglas: {
          minLength: minLength(1)
        }
      },
      formAgregar: {
        cantidad: {
          between: between(1, 9999)
        },
        idCategoria: {
          required
        }
      }
    },
    methods: {
      clickAgregarRegla () {
        const me = this
        if (me.$v.formAgregar.$invalid) {
          console.log('invalid')
          me.formAgregar.mostrarErrores = true
          return false
        }
        let existeCategoria = me.datosCombo.reglas.find((regla) => {
          return regla.categoria._id === me.formAgregar.idCategoria
        })
        if (existeCategoria) {
          me.$emit('mostrar-notificacion', 'Ya existe esa categoría en las reglas', 'error')
          return false
        }
        let categoria = me.categorias.find((cat) => {
          return cat._id === me.formAgregar.idCategoria
        })
        me.datosCombo.reglas.push({
          cantidad: me.formAgregar.cantidad,
          categoria: categoria
        })
        me.formAgregar = {
          cantidad: 0,
          idCategoria: null
        }
      },
      clickGuardarCombo () {
        const me = this
        if (me.$v.datosCombo.$invalid) {
          me.datosCombo.mostrarErrores = true
          return false
        }
        me.$http.post('/api/admin/combos', {
          combo: me.datosCombo
        }).then(({body}) => {
          me.$emit('mostrar-mensaje', 'El combo se guardó correctamente', 'success')
          me.$router.push({
            path: '/combos'
          })
        }, (err) => {
          console.error(err)
        })
      },
      eliminarRegla (idx) {
        this.datosCombo.reglas.splice(idx, 1)
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/admin/initformcombo', {
        params: {
          id: me.$route.params.id || null
        }
      }).then(({body}) => {
        me.categorias = body.categorias
        me.datosCombo.nombre = body.combo.nombre
        me.datosCombo.reglas = body.combo.reglas || []
        me.datosCombo._id = body.combo._id
      }, (err) => {
        console.error(err)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// FormCombo.vue?b5a4913e